import { render, staticRenderFns } from "./final-ribbon.vue?vue&type=template&id=e301c25e&scoped=true"
import script from "./final-ribbon.vue?vue&type=script&lang=ts"
export * from "./final-ribbon.vue?vue&type=script&lang=ts"
import style0 from "./final-ribbon.vue?vue&type=style&index=0&id=e301c25e&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e301c25e",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/src/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('e301c25e')) {
      api.createRecord('e301c25e', component.options)
    } else {
      api.reload('e301c25e', component.options)
    }
    module.hot.accept("./final-ribbon.vue?vue&type=template&id=e301c25e&scoped=true", function () {
      api.rerender('e301c25e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/final-report/final-ribbon.vue"
export default component.exports